// extracted by mini-css-extract-plugin
export const gallery = "gallery-main-module--gallery--F75OB";
export const grid = "gallery-main-module--grid--1MyNb";
export const gridRow = "gallery-main-module--grid-row--1xbQC";
export const cover = "gallery-main-module--cover--DoocW";
export const slideshow = "gallery-main-module--slideshow--2FsOo";